export enum MeditatorPassFailActions {
    PASS = "PASS",
    FAIL = "FAIL",
}